import React from "react";

const SortOrderHeader = ({ displayName, sortField, payloadSort, setSortOrderParent }) => {
  const isActive = payloadSort?.sort_by === sortField;
  const currentOrder = isActive ? payloadSort?.sort_type : null;

  const handleClickSort = () => {
    let newOrder;
    if (!isActive) {
      newOrder = "asc";
    } else if (currentOrder === "asc") {
      newOrder = "desc";
    } else if (currentOrder === "desc") {
      newOrder = null;
    }

    setSortOrderParent?.(newOrder ? { sort_by: sortField, sort_type: newOrder } : null);
  };

  return (
    <div
      className="flex items-center gap-2 justify-content-between cursor-pointer select-none w-full"
      onClick={handleClickSort}
      title={`Klik untuk mengurutkan ${displayName}`}
    >
      <span className="font-semibold text-blue-600">{displayName}</span>
      {isActive && currentOrder && (
        <i className={`text-gray-500 text-xs pi ${currentOrder === "asc" ? "pi-arrow-up" : "pi-arrow-down"}`}></i>
      )}
    </div>
  );
};

export const ColumnCutRecap = (ActionRenderer, handleSortOrder, payloadSort) => {
  return [
    {
      headerName: "No",
      field: "no",
      width: 80,
      pinned: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
    },
    {
      headerName: "Worker ID",
      field: "workerId",
      width: 200,
      flex: 1,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker ID",
        sortField: "worker_id",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Worker Name",
      field: "workerName",
      flex: 1,
      width: 200,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Name",
        sortField: "worker_name",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Worker Type",
      field: "workerType",
      width: 200,
      flex: 1,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Worker Type",
        sortField: "worker_type",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Initial Amount",
      field: "initialAmount",
      width: 200,
      flex: 1,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Initial Amount",
        sortField: "initial_amount",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      valueFormatter: (p) => `Rp ${Number(p.value || 0).toLocaleString("id-ID")}`,
    },
    {
      headerName: "Kasbon Unpaid",
      field: "totalUnpaid",
      width: 200,
      flex: 1,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Kasbon Unpaid",
        sortField: "total_unpaid",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      valueGetter: (params) => {
        const totalUnpaid = params.data.totalUnpaid ?? "-";
        return `${totalUnpaid} Transaksi`;
      },
      cellStyle: { fontWeight: "bold" },
    },
    {
      headerName: "Deduction",
      field: "deduction",
      width: 200,
      flex: 1,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Deduction",
        sortField: "deduction",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      valueFormatter: (p) => `Rp ${Number(p.value || 0).toLocaleString("id-ID")}`,
      cellStyle: (params) => ({
        fontWeight: "bold",
        color: params.value > 0 ? "red" : "",
      }),
    },
    {
      headerName: "Final Amount",
      field: "finalAmount",
      width: 200,
      flex: 1,
      sortable: false,
      filter: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      headerComponent: SortOrderHeader,
      headerComponentParams: {
        displayName: "Final Amount",
        sortField: "final_amount",
        setSortOrderParent: handleSortOrder,
        payloadSort,
      },
      cellStyle: { fontWeight: "bold" },
      valueFormatter: (p) => `Rp ${Number(p.value || 0).toLocaleString("id-ID")}`,
    },
    {
      headerName: "Action",
      field: "action",
      width: 125,
      pinned: "right",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      suppressSizeToFit: true,
      cellRenderer: ActionRenderer,
    },
  ];
};
